import { ref, watch, computed } from '@vue/composition-api'
import popups from '@/hooks/popups';
import i18n from "@/libs/i18n";
import store from "@/store";
import axios from "@axios"
import router from '@/router'

export default function cashMovementsListQuery() {
    const { errorToast } = popups()
    const perPageOptions = [10, 25, 50, 100]
    const groupFilter = ref(null)
    const cashFilter = ref(router.currentRoute.params.id)
    const groupOptions = ref([])
    const searchQuery = ref('')
    const cashTable = ref(null)
    const movementsTable = ref(null)
    const isSortDirDesc = ref(true)
    const currentPage = ref(1)
    const sortBy = ref('id')
    const perPage = ref(10)
    const totalCash = ref(0)
    const key=ref(0)

    const tableColumns = [
        { key: 'movement_type', label: i18n.t('Movement'), sortable: true },
        { key: 'amount', label: i18n.t('Amount') },
        { key: 'client', label: "Cliente" },
        { key: 'date', label: i18n.t('Fecha'), sortable: true },
        { key: 'cash', label: i18n.t('Cash'), sortable: true },
        { key: 'observations', label: 'Observaciones', sortable: true },
        { key: 'references', label: i18n.t('References') },
        { key: 'actions', label: i18n.t('Actions') }
    ]

    const dataMeta = computed(() => {
        const localItemsCount = cashTable.value ? cashTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCash.value,
        }
    });

    const refetchData = function() {
        cashTable.value.refresh()
    }

    watch([currentPage, searchQuery, perPage, groupFilter, cashFilter], () => {
        refetchData()
    })

    const fetchMovements = function(ctx, callback) {
        axios.get('movements', {params: {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            group: groupFilter.value,
            cash: cashFilter.value
        }})
        .then(response => {
            const { movements, total } = response.data
            callback(movements)
            totalCash.value = total
        })
        .catch((error) => { errorToast("Error fetching cash list"); })
    }

    return {
        fetchMovements,
        tableColumns,
        perPage,
        currentPage,
        totalCash,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        cashTable,
        refetchData,
        groupFilter,
        cashFilter,
        groupOptions,
        movementsTable,
        key
        
    }
}
